import { useTranslation } from "react-i18next";
import Logo from "@ui/Logo";

export default function SurveyExpired({ alreadySubmitted }) {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
            <div className="px-6 py-4">
                <Logo className="h-5 text-white" />
            </div>
            <div className="flex-1 flex items-center justify-center px-6">
            <div className="text-center max-w-md">
                <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-white/30" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        {alreadySubmitted ? (
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        )}
                    </svg>
                </div>
                <h2 className="text-2xl font-bold text-white mb-3">
                    {alreadySubmitted ? t("survey.alreadySubmittedTitle") : t("survey.expiredTitle")}
                </h2>
                <p className="text-white/40 text-lg">
                    {alreadySubmitted ? t("survey.alreadySubmittedBody") : t("survey.expiredBody")}
                </p>
            </div>
            </div>
        </div>
    );
}
